if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="language_code"], input[name="country_code"]'
          ),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };

        if (
          !this.elements.input ||
          !this.elements.button ||
          !this.elements.panel
        ) {
          return;
        }

        this.elements.button.addEventListener(
          'click',
          this.openSelector.bind(this)
        );

        this.elements.button.addEventListener(
          'focusout',
          this.closeSelector.bind(this)
        );

        this.addEventListener(
          'keyup',
          this.onContainerKeyUp.bind(this)
        );

        this.querySelectorAll('a[data-value]').forEach((item) => {
          item.addEventListener('click', this.onItemClick.bind(this));
        });
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.key !== 'Escape') return;

        if (
          this.elements.button.getAttribute('aria-expanded') === 'false'
        ) {
          return;
        }

        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();

        const form = this.querySelector('form');
        const selectedValue = event.currentTarget.dataset.value;

        if (!form || !selectedValue) return;

        this.elements.input.value = selectedValue;

        // 日本以外の国を選択したときだけ英語に切り替える。
        // 言語メニューで日本語を選ぶ操作には干渉しない。
        if (
          this.elements.input.name === 'country_code' &&
          selectedValue.toUpperCase() !== 'JP'
        ) {
          let languageInput = form.querySelector(
            'input[name="language_code"]'
          );

          if (!languageInput) {
            languageInput = document.createElement('input');
            languageInput.type = 'hidden';
            languageInput.name = 'language_code';
            form.appendChild(languageInput);
          }

          languageInput.value = 'en';

          form.querySelectorAll('input[name="locale_code"]').forEach(
            (input) => {
              input.value = 'en';
            }
          );
        }

        form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');

        this.elements.button.setAttribute(
          'aria-expanded',
          (
            this.elements.button.getAttribute('aria-expanded') === 'false'
          ).toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) ||
          this.elements.button.contains(event.relatedTarget);

        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}